module.exports = __webpack_public_path__ + "img/ico061.6380691a.svg";